import React from "react";
import { Container } from "react-bootstrap";
import { connectStats } from "react-instantsearch-core";
import './Banner.scss';
import _ from "lodash";

const SearchBanner = (props) => {
    return (
        <section className="Search-banner">
            <Container>
                <div className="row ">
                    <div className="col-md-12 ">
                        <span className="sm-text ">
                            {props.nbHits} Property {props.searchType === "lettings" ? 'to rent' : 'for sale'} in {props.query === "" & props.bannerVal.length >= 1 && props.bannerVal || props.query === "" & props.bannerVal.length === 0 && " SOUTH BUCKINGHAMSHIRE AND BERKSHIRE" || props.query.length >= 0 && props.query.split("-").map(c => _.upperFirst(c)).join(" ")}
                        </span>
                        <h1>Beautiful Property in the heart of {props.query === "" ? "South Buckinghamshire and Berkshire" : props.query.split("-").map(c => _.upperFirst(c)).join(" ")} </h1>
                        <p className="onscroll-react-class">
                            {/* Find the best property {props.searchType === "lettings" ? 'to rent' : 'for sale'} in {props.query === "" ? "Buckinghamshire" : props.query}. Contact our property experts and get help to find property {props.searchType === "lettings" ? 'to rent' : 'for sale'}  */}
                            {props.searchType === "lettings" ? "Here are you can view a selection of what we have to offer to rent. Please get in touch and register with us so we can keep you up to date with any properties which are yet to go live on our website. Some of our clients request we discreetly market their property so the more we understand about your search, the more value we can add to the process." : 
                            `Find the best property for sale in ${props.query === "" ? "South Buckinghamshire and Berkshire" : props.query.split("-").map(c => _.upperFirst(c)).join(" ")}. Contact our property experts and get help to find property for sale`}
                                {/* in [Area/Postcode]. */}
                        </p>
                    </div>
                </div>
            </Container>
        </section>
    )
};
export default connectStats(SearchBanner)